import React from "react";
import { useSelector } from "react-redux";
import { Typography } from "components";
import { FiInfo } from "react-icons/fi";
import wavingHand from "assets/images/waving-hand.png";

const PendingApproval = () => {
  const { user } = useSelector((state) => state.user);
  return (
    <div className="new-account-container">
      <Typography variant="heading3" state="primary" component="h3">
        Welcome {user?.corporate_name || user?.firstname}{" "}
        <img src={wavingHand} width="30" alt="" />,
      </Typography>
      <div className="mt-4 d-flex info-container">
        <span>
          <FiInfo color="#1966FC" fontSize="20px" />
        </span>
        &nbsp; &nbsp; &nbsp;
        <Typography variant="body1" state="primary">
          **Your submitted details are currently undergoing verification and
          approval. This should take no longer than 48 hours. You will be
          notified upon account approval.
        </Typography>
      </div>
    </div>
  );
};

export default PendingApproval;
